import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { memo, useEffect } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { closeErrorDialog } from './redux/actions';
import { Typography } from '@mui/material';
import { MessageBox } from 'shared/components/dialogs/message-box';
const ErrorDialogImpl = memo(function ErrorDialogImpl(props) {
    const { dialog_state, onClose } = props;
    const { open, error, error_ui } = dialog_state;
    useEffect(() => {
        if (open && error_ui != null) {
            console.groupCollapsed('ERROR!!! ' + error_ui);
            console.error(error_ui);
            console.error(error);
            console.groupEnd();
        }
    }, [open, error, error_ui]);
    return (_jsx(MessageBox, { open: open, onClose: onClose, maxWidth: "xs", closeButtonTitle: "\u041E\u043A", isError: true, children: _jsx(Typography, { variant: "subtitle1", color: "textSecondary", children: error_ui != null ? error_ui : 'Что-то пошло не так' }) }));
});
const ErrorDialogKey = (props) => {
    return _jsx(ErrorDialogImpl, { ...props }, props.dialog_state.randomKey);
};
export const ErrorDialog = connect(createStructuredSelector({
    dialog_state: (state) => state.error_dialog,
}), { onClose: closeErrorDialog })(ErrorDialogKey);
